import React from 'react'
import { bool } from 'prop-types'
import styled from 'styled-components'

import { Container, DesktopLogo, MobileLogo, LogoWrap } from 'components/Nav'

const LogoContainer = styled(LogoWrap)`
  cursor: default;
`

const EmptyNav = ({ transparent }) => (
  <Container transparent={transparent}>
    <LogoContainer transparent={transparent}>
      <DesktopLogo transparent={transparent} />
      <MobileLogo transparent={transparent} />
    </LogoContainer>
  </Container>
)

EmptyNav.propTypes = {
  transparent: bool
}

export default EmptyNav
